import { Box, Typography } from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import CategoryEditor from './CategoryEditor';
import ItemEditor from './ItemEditor';

const DetailPanel = ({ selectedEntity, selectedEntityType, menuMap }) => {
  if (!selectedEntityType) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          p: 4,
        }}
      >
        <CategoryIcon sx={{ fontSize: 80, color: '#9E9EAD', mb: 2 }} />
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            color: '#626A7A',
          }}
        >
          No Selection
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{
            color: '#9E9EAD',
            maxWidth: '400px',
          }}
        >
          Select a category or item from the tree on the left to view and edit
          its details
        </Typography>
      </Box>
    );
  }

  // Keyed by entity: switching selection starts a fresh editor, so saved
  // indicators and expanded panels don't carry over to the next entity
  const editorKey = selectedEntity?._id || 'new';

  return (
    <Box sx={{ p: 4, height: '100%', overflow: 'auto' }}>
      {selectedEntityType === 'category' && (
        <CategoryEditor
          key={editorKey}
          category={selectedEntity}
          menuMap={menuMap}
        />
      )}
      {selectedEntityType === 'item' && (
        <ItemEditor key={editorKey} item={selectedEntity} menuMap={menuMap} />
      )}
    </Box>
  );
};

export default DetailPanel;





